import { FC } from 'react'
import { useNavigate } from 'react-router-dom'

import AccountCircleIcon from '@mui/icons-material/AccountCircle'
import LogoutIcon from '@mui/icons-material/Logout'
import MenuIcon from '@mui/icons-material/Menu'
import { IconButton, Toolbar, Typography } from '@mui/material'
import { appName } from 'constants/app'
import { Routes } from 'constants/routes'
import { useLogout } from 'hooks/useLogout'

import { AppBar } from './AppBar'

interface HeaderProps {
  isOpen: boolean
  toggleDrawer: VoidFunction
}

export const Header: FC<HeaderProps> = ({ isOpen, toggleDrawer }) => {
  const navigate = useNavigate()

  const { logout } = useLogout()

  const onClickProfile = () => {
    navigate(Routes.Profile)
  }

  return (
    <AppBar isOpen={isOpen} position="absolute">
      <Toolbar
        sx={{
          pr: '24px', // keep right padding when drawer closed
        }}
      >
        <IconButton
          aria-label="open drawer"
          color="inherit"
          edge="start"
          onClick={toggleDrawer}
          sx={{
            marginRight: '36px',
            ...(isOpen && { display: 'none' }),
          }}
        >
          <MenuIcon />
        </IconButton>
        <Typography color="inherit" component="h1" noWrap sx={{ flexGrow: 1 }} variant="h6">
          {appName}
        </Typography>
        <IconButton color="inherit" onClick={onClickProfile} sx={{ mx: 1 }}>
          <AccountCircleIcon />
        </IconButton>
        <IconButton color="inherit" onClick={logout}>
          <LogoutIcon />
        </IconButton>
      </Toolbar>
    </AppBar>
  )
}
